import React from 'react';

const PhotoPickerControls = ({ config, onChange }) => {
  const handleChange = (key, value) => {
    onChange({ [key]: value });
  };

  return (
    <div className="space-y-6">
      {/* Selection Mode */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Selection Mode
        </label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {['single', 'multiple'].map((mode) => (
            <button
              key={mode}
              onClick={() => handleChange('selectionMode', mode)}
              className={`
                px-4 py-2 rounded-lg text-sm font-medium transition-all
                ${
                  config.selectionMode === mode
                    ? 'bg-gradient-primary text-white'
                    : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
                }
              `}
            >
              {mode.charAt(0).toUpperCase() + mode.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {/* Max Selection Count (for multiple) */}
      {config.selectionMode === 'multiple' && (
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Max Selection Count: {config.maxSelectionCount}
          </label>
          <input
            type="range"
            min="2"
            max="20"
            value={config.maxSelectionCount}
            onChange={(e) => handleChange('maxSelectionCount', parseInt(e.target.value))}
            className="w-full"
          />
        </div>
      )}

      {/* Image Picker Section */}
      <div className="border-t border-gray-200 dark:border-gray-700 pt-4">
        <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-3">Image Picker</h3>
        <div className="space-y-3">
          <div>
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              <input
                type="checkbox"
                checked={config.enableCamera !== false}
                onChange={(e) => handleChange('enableCamera', e.target.checked)}
                className="rounded"
              />
              Enable Camera
            </label>
          </div>
          <div>
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              <input
                type="checkbox"
                checked={config.enableGallery !== false}
                onChange={(e) => handleChange('enableGallery', e.target.checked)}
                className="rounded"
              />
              Enable Photo Gallery
            </label>
          </div>
        </div>
      </div>

      {/* Video Support */}
      <div className="border-t border-gray-200 dark:border-gray-700 pt-4">
        <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-3">Video Support</h3>
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
            <input
              type="checkbox"
              checked={config.allowVideos || false}
              onChange={(e) => handleChange('allowVideos', e.target.checked)}
              className="rounded"
            />
            Allow Videos
          </label>
        </div>
      </div>

      {/* Document Picker */}
      <div className="border-t border-gray-200 dark:border-gray-700 pt-4">
        <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-3">Document Picker</h3>
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
            <input
              type="checkbox"
              checked={config.enableDocumentPicker || false}
              onChange={(e) => handleChange('enableDocumentPicker', e.target.checked)}
              className="rounded"
            />
            Enable Document Picker
          </label>
        </div>
      </div>

      {/* Cropper Options */}
      <div className="border-t border-gray-200 dark:border-gray-700 pt-4">
        <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-3">Image Cropping</h3>
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
            <input
              type="checkbox"
              checked={config.cropEnabled}
              onChange={(e) => handleChange('cropEnabled', e.target.checked)}
              className="rounded"
            />
            Enable Image Cropping
            <span className="text-xs text-gray-500 dark:text-gray-400">(applies to photos from camera/gallery)</span>
          </label>
          {config.cropEnabled && (
            <div className="mt-3">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Crop Shape
              </label>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                {['square', 'circle', 'rectangle'].map((shape) => (
                  <button
                    key={shape}
                    onClick={() => handleChange('cropShape', shape)}
                    className={`
                      px-3 py-2 rounded-lg text-xs font-medium transition-all
                      ${
                        config.cropShape === shape
                          ? 'bg-gradient-primary text-white'
                          : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
                      }
                    `}
                  >
                    {shape.charAt(0).toUpperCase() + shape.slice(1)}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PhotoPickerControls;

